import { Check, Inbox, ShoppingBag, UserRound, type LucideIcon } from 'lucide-react';

import { cx } from '@/shared/lib/cx';

import { orderedFeatures, SITE_FEATURES, type SiteFeature } from './siteSetup';
import styles from './FeatureTiles.module.scss';

const ICONS: Record<SiteFeature, LucideIcon> = {
  users: UserRound,
  shop: ShoppingBag,
  forms: Inbox,
};

export interface FeatureTilesProps {
  value: SiteFeature[];
  onChange: (value: SiteFeature[]) => void;
  disabled?: boolean;
}

/**
 * Возможности сайта плитками: одни и те же при создании сайта и в
 * «Настройках → Возможности». Плитка целиком — переключатель: попасть по
 * крупной карточке проще, чем по флажку в 16 пикселей.
 */
export function FeatureTiles({ value, onChange, disabled }: FeatureTilesProps) {
  return (
    <div className={styles['tiles']} role="group" aria-label="Что будет на сайте">
      {SITE_FEATURES.map((feature) => {
        const Icon = ICONS[feature.key];
        const checked = value.includes(feature.key);

        return (
          <button
            key={feature.key}
            type="button"
            role="checkbox"
            aria-checked={checked}
            disabled={disabled}
            className={cx(styles['tile'], checked && styles['tile--checked'])}
            onClick={() => {
              // Порядок — как в карточках, а не как нажимали.
              onChange(
                orderedFeatures(
                  checked ? value.filter((k) => k !== feature.key) : [...value, feature.key],
                ),
              );
            }}
          >
            <span className={styles['tile__icon']}>
              <Icon size={20} />
            </span>
            <span className={styles['tile__body']}>
              <span className={styles['tile__title']}>{feature.title}</span>
              <span className={styles['tile__text']}>{feature.text}</span>
            </span>
            <span className={styles['tile__mark']} aria-hidden>
              <Check size={14} strokeWidth={3} />
            </span>
          </button>
        );
      })}
    </div>
  );
}
